// reactstrap Badge color values for ticket status
export const statusColorMap = {
  Open: 'primary',
  'In Progress': 'warning',
  'Waiting for customer': 'info',
  Escalated: 'danger',
  Done: 'success',
  Resolved: 'success',
  Closed: 'secondary',
};
